module.exports = __webpack_public_path__ + "static/media/team_9.97e1ae82.jpg";